module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.backgroundVariant === 'image') ? _c('v-img', {
    attrs: {
      "src": _vm.backgroundUrl,
      "lazy-src": "/static/background.webp",
      "cover": "",
      "height": "100%",
      "width": "100%"
    }
  }, [_c('signinCard')], 1) : _c('span', [_c('canvas', {
    ref: "canvas"
  }), _vm._v(" "), _c('signinCard')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-498f9206"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Signin.vue
// module id = 772
// module chunks = 15